import { CategoryCard } from '@/cards/CategoryCard';
import { CategoryType } from '@vimond/services/content-discovery';
import { Suspense } from 'react';

type Props = {
  categories?: CategoryType[];
  title?: string;
};

export const CategoryGrid = ({
  categories,
  title,
}: Props & React.ComponentPropsWithoutRef<'section'>) => {
  return (
    <section className="mx-3 p-4 lg:mx-10">
      <h1 className="my-2 text-2xl font-bold">{title}</h1>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {categories?.map((category) => (
          <Suspense key={category.id}>
            <CategoryCard category={category} key={category.id} />
          </Suspense>
        ))}
      </div>
    </section>
  );
};
